"use strict";
/**
 * Returns a phone number in the international telephone numbers format.
 *
 * @remarks
 * Format: +[country code][subscriber number including area code]
 * where the country code is a single to three digit number and the
 * subscriber number is a variable length number.
 * The leading plus sign is mandatory and always added to the number.
 * More details: https://en.wikipedia.org/wiki/E.164
 *
 * @param phoneNumber - The phone number to be transformed
 * @returns The phone number in the international telephone numbers format, or
 *          an empty string if the phone number is undefined or null.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPhoneNumberToNormalizedForm = void 0;
function cleanPhoneNumber(phoneNumber) {
    const result = phoneNumber.replace(/^00|[^0-9]/g, "");
    return result;
}
function transformPhoneNumberToNormalizedForm(phoneNumber) {
    return phoneNumber?.trim() ? `+${cleanPhoneNumber(phoneNumber)}` : "";
}
exports.transformPhoneNumberToNormalizedForm = transformPhoneNumberToNormalizedForm;
//# sourceMappingURL=transformPhoneNumberToNormalizedForm.js.map